var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarifas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6E6259",
    fillRule: "nonzero",
    stroke: "#6E6259",
    strokeWidth: 0.4
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.742 1.367c-.182-.206-.434-.328-.708-.345L3.348.002C2.782-.032 2.293.4 2.258.966l-.226 3.7H1.03C.462 4.667 0 5.129 0 5.697v9.729c0 .568.462 1.03 1.029 1.03h16.717c.567 0 1.029-.462 1.029-1.03v-2.67l.54.033.063.002c.539 0 .993-.422 1.026-.966l.594-9.712c.017-.274-.074-.539-.256-.745zm-2.788 14.058c0 .115-.093.209-.208.209H1.029c-.115 0-.209-.094-.209-.209V8.421h14.75c.226 0 .41-.184.41-.41 0-.227-.184-.41-.41-.41H.82V5.695c0-.115.094-.209.209-.209h16.717c.115 0 .208.094.208.209v9.73zm2.179-12.602L6.069 1.967c-.227-.014-.42.158-.434.384-.014.226.158.42.384.435l14.064.856-.498 8.131c-.007.115-.106.203-.22.196l-.59-.036V5.696c0-.568-.462-1.03-1.03-1.03H2.855l.223-3.65c.007-.115.107-.202.221-.195l16.686 1.02c.075.005.122.046.143.07.022.024.057.076.052.15l-.046.762z",
    transform: "translate(-20 -562) translate(20 562) translate(0 2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.821 13.286c-.005-.026-.013-.052-.023-.077-.01-.024-.023-.048-.038-.07-.015-.023-.032-.044-.05-.063-.096-.095-.238-.139-.371-.112-.026.005-.052.013-.077.023s-.048.023-.07.038c-.023.015-.044.032-.063.051-.02.02-.036.04-.051.063-.015.022-.028.046-.038.07-.01.025-.018.051-.023.077-.006.027-.008.054-.008.08 0 .027.002.054.008.08.005.027.013.052.023.077s.023.049.038.071c.015.023.032.043.051.062.019.02.04.036.062.051.023.015.046.028.071.038.025.01.05.018.077.023.026.006.053.008.08.008.108 0 .214-.043.29-.12.019-.019.036-.04.05-.062.016-.022.028-.046.039-.071.01-.025.018-.05.023-.077.005-.026.008-.053.008-.08 0-.026-.003-.053-.008-.08zM6.527 12.956H4.06c-.227 0-.41.184-.41.41 0 .227.183.41.41.41h2.467c.227 0 .41-.183.41-.41 0-.226-.183-.41-.41-.41z",
    transform: "translate(-20 -562) translate(20 562) translate(0 2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarifas);
export default __webpack_public_path__ + "static/media/tarifas.b987d1a4.svg";
export { ForwardRef as ReactComponent };